<template>
  <shop-data>
    <ShopArticle v-if="article">
      <ArticleHeader
        :icon="article.iconUrl"
        :large="
          article.name.indexOf('tasche') > -1 ||
          article.name.indexOf('Shirt') > -1 ||
          article.name.indexOf('Jacke') > -1 ||
          article.name.indexOf('brett') > -1
        "
      ><!-- TODO take article spec for future -->
        {{ article.name }}
      </ArticleHeader>
      <ArticleDescription v-html="article.description"> </ArticleDescription>
      <ArticlePrice :cadence="article.articleType === 2 ? '' : t('shop.month')">
        {{ roundPrice(article.vatPrice) }} €
      </ArticlePrice>
      <Alert v-if="bookingError">{{ t('shop.bookingError') }}</Alert>
      <Alert v-if="consentMissingError && !consent">
        {{ t('shop.consentRequired') }}
      </Alert>
      <div class="consent">
        <input v-model="consent" id="consent" type="checkbox" />
        <label for="consent">
          {{ t('shop.consentPrefix') }}
          <a target="_blank" rel="noopener noreferrer" :href="tosUrl">{{ t('shop.consentTerms') }}</a>,
          {{ t('shop.consentMiddle') }}
          <a target="_blank" rel="noopener noreferrer" :href="privacyUrl"
          >{{ t('shop.consentPrivacy') }}</a
          >
          {{ t('shop.consentSuffix') }}
        </label>
      </div>
      <div class="consent" v-if="article.articleType === 2">
        <input v-model="sepaConsent" id="sepaConsent" type="checkbox" />
        <label for="sepaConsent">
          {{ t('shop.sepaConsent') }}
        </label>
      </div>
      <LinkButton
        v-if="!bookableLater"
        :form="formId"
        icon-right="cart"
        :extra-classes="['article__cta']"
        :disableOnSubmit="true"
        @click.native="onBookArticle"
        :text="bookText"
      ></LinkButton>
      <p v-if="bookableLater" class="article__bookableLater">
        {{ t('shop.bookableLater') }}
      </p>
      <ArticleDates v-if="article.cancellationNotice">
        <dt>{{ t('shop.cancellationNotice') }}</dt>
        <dd>
          <time>
            {{ formatCancellationDate(article.cancellationNotice) }}
          </time>
        </dd>
      </ArticleDates>
      <ContainedArticles :containedArticles="article.containedArticles" />
    </ShopArticle>
  </shop-data>
</template>
<script setup>
  import { computed, ref } from 'vue'
  import { useStrings } from '@/composables/useStrings.ts'
  import ContainedArticles from '@/components/shop/ContainedArticles.vue'
  import ArticleDates from '@/components/shop/ArticleDates.vue'
  import ArticleDescription from '@/components/shop/ArticleDescription.vue'
  import ShopArticle from '@/components/shop/ShopArticle.vue'
  import ArticlePrice from '@/components/shop/ArticlePrice.vue'
  import Alert from '@/components/Alert.vue'
  import ShopData from '@/components/shop/ShopData.vue'
  import LinkButton from '@/components/LinkButton.vue'
  import ArticleHeader from '@/components/shop/ArticleHeader.vue'
  import { legalUrls } from '@/composables/useLegal.ts'
  import { useShopStore } from '@/stores/useShopStore'
  import { useFormsStore } from '@/stores/useFormsStore'
  import { useRouter } from 'vue-router'
  import { useUnits } from '@/composables/useUnits.ts'
  import { useDate } from '@/composables/useDate.ts'

  const { t } = useStrings()
  const shopStore = useShopStore()
  const formsStore = useFormsStore()
  const router = useRouter()
  const { roundPrice } = useUnits()
  const { formatCancellationDate } = useDate()

  const id = Number(router.currentRoute.value.params.id)
  const article = computed(() => shopStore.getArticle(id))
  const formId = `buy-${id}`
  const consent = ref(false)
  const sepaConsent = ref(false)
  const consentMissingError = ref(false)

  const bookText = computed(() =>
    shopStore.getArticle(id)?.articleType === 2
      ? t('shop.orderButton')
      : t('shop.bookButton')
  )

  const bookableLater = computed(() => shopStore.inactive === true)

  const bookingError = computed(() => formsStore.getFormState(formId) === 'error')

  const onBookArticle = async () => {
    if (!consent.value) {
      consentMissingError.value = true
      return
    }
    consentMissingError.value = false
    formsStore.setFormState(formId, 'submitting')
    await shopStore.bookArticle({ articleId: id, consent: consent.value })

    if (!bookingError.value) {
      router.push({
        name: 'shop',
        // Vuejs's router does not allow for undefined parameters anymore.
        // We append a get parameter instead, which means that the success
        // message will persist when reloading the success page.
        query: { booked: 1 },
      })
    }
  }
  const { tosUrl, privacyUrl } = legalUrls()
</script>
<style lang="scss" scoped>
.consent {
  display: flex;
  accent-color: $community;
  line-height: $line-height-sm;

  input {
    $size: 1.2em;
    flex-basis: $size;
    flex-shrink: 0;
    width: $size;
    height: $size;
  }
}

.article__bookableLater {
  margin-bottom: $spacer30;
  clear: left;
  font-weight: bold;
}
</style>
